module.exports = __webpack_public_path__ + "img/close.786251f5.svg";